import { ReportFileViewerPage } from '@/features/reports/report-file-viewer-page';

const ReportViewerPage = () => <ReportFileViewerPage backLabel="Back to Reports" backTo="/compliance/reports" />;
ReportViewerPage.displayName = 'ReportViewerPage';

export default ReportViewerPage;
